import type {FindingReference} from '@github-ui/copilot-chat-types'
import type {Finding} from './types'

/**
 * Builds a first-class `finding` Copilot Chat reference from a finding so it can
 * be attached to a conversation. The reference mirrors the canonical
 * `APIFinding` shape (see `Finding` in ./types and the copilot-chat service's
 * `finding` reference type), and the chat service renders its content into the
 * prompt — no pre-baked text blob is needed here.
 *
 * Findings are identified (and de-duplicated) by their unique `id`, so multiple
 * findings — even grouped ones sharing a `groupTitle` — can be attached side by
 * side without replacing one another.
 */
export const buildFindingChatReference = (finding: Finding): FindingReference => ({
  type: 'finding',
  id: finding.id,
  filePath: finding.filePath,
  startLine: finding.startLine,
  endLine: finding.endLine,
  startColumn: finding.startColumn,
  endColumn: finding.endColumn,
  message: finding.message,
  ruleId: finding.ruleId,
  category: finding.category,
  severity: finding.severity,
  groupTitle: finding.groupTitle,
  suggestion: finding.suggestion,
  approvalReadiness: finding.approvalReadiness,
  fileUrl: finding.fileUrl ?? undefined,
})
